import { Truck, Zap, Mail } from "lucide-react";

export default function ShippingPolicy() {
    return (
        <div className="max-w-3xl mx-auto px-6 py-16" data-testid="shipping-policy-page">
            <div className="mb-10">
                <div className="overline mb-3">Legal</div>
                <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-4">
                    Shipping Policy<span className="text-accent">.</span>
                </h1>
                <p className="text-zinc-500">Last updated: February 2026</p>
            </div>

            <div className="surface p-8 mb-6 flex items-start gap-4">
                <div className="w-10 h-10 rounded-md border border-accent/30 bg-accent/10 flex-shrink-0 flex items-center justify-center">
                    <Zap className="w-4 h-4 text-accent" strokeWidth={1.75} />
                </div>
                <div>
                    <h2 className="font-heading text-lg font-semibold text-zinc-100 mb-1">
                        listcraft is a fully digital service
                    </h2>
                    <p className="text-sm text-zinc-400 leading-relaxed">
                        We do not ship any physical goods. All deliverables — AI-generated product titles,
                        descriptions, bullet points, meta tags and variant copy — are delivered instantly
                        inside your listcraft dashboard.
                    </p>
                </div>
            </div>

            <div className="space-y-8 text-zinc-300 leading-relaxed">
                <section>
                    <h3 className="font-heading text-xl font-semibold text-zinc-100 mb-3 flex items-center gap-2">
                        <Truck className="w-4 h-4 text-accent" /> Digital delivery
                    </h3>
                    <p className="text-sm text-zinc-400">
                        Once your payment is successfully captured by our payment gateway (Razorpay), credits
                        are added to your account immediately. You can use them to generate listings from
                        the <span className="text-zinc-200">Generate</span> page and view all your outputs
                        under <span className="text-zinc-200">Dashboard</span>.
                    </p>
                </section>

                <section>
                    <h3 className="font-heading text-xl font-semibold text-zinc-100 mb-3">Delivery timeline</h3>
                    <ul className="space-y-2 text-sm text-zinc-400 list-disc pl-5">
                        <li>Credits are added within a few seconds after successful payment.</li>
                        <li>Each listing is generated in under 30 seconds in most cases.</li>
                        <li>Premium plan users are served through a priority processing queue.</li>
                    </ul>
                </section>

                <section>
                    <h3 className="font-heading text-xl font-semibold text-zinc-100 mb-3">If credits are not added</h3>
                    <p className="text-sm text-zinc-400 mb-2">
                        In the rare case that your payment was captured but credits are not reflected within
                        30 minutes, please email us with your registered email address and the payment
                        reference ID. We will reconcile and add credits (or issue a refund) within 3 business
                        days.
                    </p>
                </section>

                <section>
                    <h3 className="font-heading text-xl font-semibold text-zinc-100 mb-3 flex items-center gap-2">
                        <Mail className="w-4 h-4 text-accent" /> Contact
                    </h3>
                    <p className="text-sm text-zinc-400">
                        Ari Enterprises · <a href="mailto:arienterprises50@gmail.com" className="text-accent hover:underline">arienterprises50@gmail.com</a>
                    </p>
                </section>
            </div>
        </div>
    );
}
